import { ScriptAdapter } from "./ScriptAdapter";
import * as isMobile from "ismobilejs";
import { ProjectDomUtils } from "../../utils/ProjectDomUtils";
import { Subscription } from "../../listeners/Subscription";
export var TagManagerScriptAdapterSubs;
(function (TagManagerScriptAdapterSubs) {
    TagManagerScriptAdapterSubs[TagManagerScriptAdapterSubs["onZIndexChanged"] = 0] = "onZIndexChanged";
})(TagManagerScriptAdapterSubs || (TagManagerScriptAdapterSubs = {}));
export class TagManagerScriptAdapter extends ScriptAdapter {
    constructor() {
        super(...arguments);
        this._script = '<script async="async" src="https://www.googletagservices.com/tag/js/gpt.js"></script>';
        this._global = 'googletag';
        this._slotPrefix = 'slot_';
        this._definedSlots = [];
        this._slotNames = {};
        this._targeting = [];
        this._runComplete = false;
        this.listener = new Subscription();
        this._highestZIndex = -1;
    }
    get highestZIndex() {
        return this._highestZIndex;
    }
    isEnv(env) {
        if (isMobile.tablet) {
            return env === 'tablet';
        }
        else if (isMobile.any) {
            return env === 'mobile';
        }
        else {
            return env === 'desktop';
        }
    }
    init(data) {
        this._highestZIndex = ProjectDomUtils.getHighestZIndex(document);
        this._data = data;
    }
    initLazy() {
        if (!this._initPromise) {
            this._initPromise = this.runScript(this._script, this._global).then(() => {
                this._googletag = this._contextWindow[this._global] = this._contextWindow[this._global] || {};
                this._googletag.cmd = this._googletag.cmd || [];
                this._data.params.elements.forEach((elem) => {
                    if (this.isEnv(elem.env)) {
                        this._slotNames[elem.slot] = elem;
                        this.defineSlot(elem.slot);
                    }
                });
                this.runTagManager();
                this._googletag.cmd.push(() => {
                    this._definedSlots.forEach((data) => {
                        this.displaySlot(data.name);
                    });
                });
            }).catch((e) => {
                logger.error(e);
            });
        }
        return this._initPromise;
    }
    runTagManager() {
        this._googletag.cmd.push(() => {
            if (this._targeting.length > 0) {
                log('targeting:');
                log(this._targeting);
                this._googletag.pubads().setTargeting('content', this._targeting);
            }
            this._googletag.pubads().enableSingleRequest();
            this._googletag.pubads().collapseEmptyDivs();
            this._googletag.pubads().addEventListener('slotRenderEnded', (event) => {
                this._highestZIndex = ProjectDomUtils.getHighestZIndex(document);
                this.listener.inform(TagManagerScriptAdapterSubs.onZIndexChanged);
            });
            this._googletag.pubads().addEventListener('impressionViewable', function (event) {
                log('impressionViewable:');
                log(event);
            });
            this._googletag.pubads().addEventListener('slotOnloadEvent', function (event) {
                log('SlotOnloadEvent');
                log(event);
            });
            this._googletag.enableServices();
            this._runComplete = true;
        });
    }
    defineSlot(slotName) {
        this._googletag.cmd.push(() => {
            const elem = this._slotNames[slotName];
            if (elem) {
                if (this.isEnv(elem.env)) {
                    if (elem.slot) {
                        const slotID = this._slotPrefix + elem.slot;
                        let mapping = null;
                        if (elem.size_mapping.length > 0) {
                            let mappingBuilder = this._googletag.sizeMapping();
                            elem.size_mapping.forEach((sizeMap) => {
                                mappingBuilder = mappingBuilder.addSize.apply(mappingBuilder, sizeMap);
                            });
                            mapping = mappingBuilder.build();
                        }
                        let slotTag = this._googletag.defineSlot(elem.ref, elem.size, slotID);
                        if (mapping) {
                            slotTag = slotTag.defineSizeMapping(mapping);
                        }
                        slotTag = slotTag.addService(this._googletag.pubads());
                        const data = {
                            adUnitPath: elem.ref,
                            name: elem.slot,
                            id: slotID,
                            tagData: slotTag
                        };
                        this._definedSlots.push(data);
                        logger.log('define slot:');
                        logger.dir(elem);
                    }
                }
                else {
                    logger.error('Cant add slot ' + slotName);
                }
            }
            else {
                logger.error('Cant find slot ' + slotName);
            }
        });
    }
    setTargeting(targeting) {
        if (this._runComplete) {
            logger.error('cant set targeting.');
        }
        else if (targeting.length > 0) {
            targeting.forEach((tag) => {
                if (this._targeting.indexOf(tag) === -1) {
                    this._targeting.push(tag);
                }
            });
        }
    }
    getSlotElementByName(slotName) {
        return document.getElementById(this._slotPrefix + slotName);
    }
    displaySlot(slotName) {
        this._googletag.cmd.push(() => {
            const slot = this.getDefinedSlotByName(slotName);
            if (slot) {
                if (this.getSlotElementByName(slot.name)) {
                    logger.log('display slot:');
                    logger.dir(slot);
                    this._googletag.display(slot.id);
                }
                else {
                    logger.warn('display slot not found ' + slot.id);
                }
            }
        });
    }
    getDefinedSlotByID(id, optional = false) {
        return this.getDefinedSlotBy({ id }, optional);
    }
    getDefinedSlotByUnitPath(adUnitPath, optional = false) {
        return this.getDefinedSlotBy({ adUnitPath }, optional);
    }
    getDefinedSlotByName(name, optional = false) {
        return this.getDefinedSlotBy({ name }, optional);
    }
    getDefinedSlotBy(data, optional = false) {
        let slot = null;
        this._definedSlots.some((checkSlot) => {
            for (let prop in data) {
                if (checkSlot[prop] === data[prop]) {
                    slot = checkSlot;
                    return true;
                }
            }
            return false;
        });
        if (!slot && !optional) {
            logger.error('cant find slot ' + slot);
            log(data);
        }
        return slot;
    }
    refreshSlotByName(name, optional = false) {
        const slot = this.getDefinedSlotByName(name, optional);
        if (slot) {
            this.refreshSlots([slot]);
        }
    }
    refreshSlots(slots) {
        if (slots.length > 0) {
            this._googletag.cmd.push(() => {
                log('refreshSlots');
                log(slots);
                this._googletag.pubads().refresh(slots.map(slot => slot.tagData));
            });
        }
    }
}
